import secondaryComponents from "../..";
import Images from "../../../../assets/images";
import { useStoreAssignedTerminals } from "./useStoreAssignedTerminals";

export const StoreAssignedTerminals = ({
  deviceList,
  metaDetails = {},
  gotoPage = () => {},
  onAssignment = () => {},
}) => {
  const { instance } = useStoreAssignedTerminals({
    deviceList,
    onAssignment,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="text-center my-5">
          <img
            width="250px"
            height="262px"
            src={Images.tnxEmptyState}
            alt="empty state"
          />
          <h4 className="font-weight-semibold text-center mt-4">
            No terminal found
          </h4>
          <p className="text-center">
            Use the button above to add a terminal. When you do, they would
            appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {deviceList?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}
    </>
  );
};
